<script>
export default {
  props: {
    lastLoadedData: Object
  },
}
</script>

<template>
  <div class="card rounded-3 mb-3 card-simple" v-if="this.lastLoadedData?._totalUnfiltered > 0">
    <div class="card-header">
      <h4>{{ $t('lists: members import stats') }}</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <div class="small">{{ $t('lists: members import state') }}</div>
          <span class="badge text-wrap" :class="`badge-${this.lastLoadedData._upload.state_style}`" v-if="this.lastLoadedData._upload !== null"><i :class="this.lastLoadedData._upload.state_icon"></i> {{ this.lastLoadedData._upload.state_name }}</span>
          <span v-if="this.lastLoadedData._upload === null">-</span>
        </div>
        <div class="col-3">
          <div class="small">{{ $t('lists: members import count') }}</div>
          <strong>{{ this.lastLoadedData?._totalUnfiltered }}</strong>
        </div>
        <div class="col-3">
          <div class="small">{{ $t('lists: members import success') }}</div>
          <strong class="text-success">{{ this.lastLoadedData?._validMembersCount }} <i class="ph ph-check-circle"></i></strong>
        </div>
        <div class="col-3">
          <div class="small">{{ $t('lists: members import failed') }}</div>
          <strong class="text-danger">{{ this.lastLoadedData?._totalUnfiltered - this.lastLoadedData?._validMembersCount }} <i class="ph ph-x-circle"></i></strong>
        </div>
      </div>
    </div>
  </div>
</template>